import { render, staticRenderFns } from "./selected-object-info.vue?vue&type=template&id=95a5e4e8"
import script from "./selected-object-info.vue?vue&type=script&lang=js"
export * from "./selected-object-info.vue?vue&type=script&lang=js"
import style0 from "./selected-object-info.vue?vue&type=style&index=0&id=95a5e4e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports